import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProjectMemberModel } from 'src/app/ViewModel/ProjectMemberModel';
import { ProjectMemberLinkService } from 'src/app/Service/projectMemberLink/project-member-link.service';
import { EIPAutoCompleteEventModel } from 'src/app/ViewModel/EIPAutoCompleteEventModel';
import { groupBy } from 'lodash';
import { IDocumentShareModel, DocumentShareMemberModel, IDocumentShareMailModel } from 'src/app/ViewModel/DocumentModel';
import { DocumentService } from 'src/app/Service/document/document.service';
import { StandardOutputModel } from 'src/app/ViewModel/StandardOutputModel';
import { NotificationService } from 'src/app/Service/notification.service';
import { Subscription } from 'rxjs/internal/Subscription';


@Component({
  selector: 'app-employee-cart-dialog',
  templateUrl: './employee-cart-dialog.component.html',
  styleUrls: ['./employee-cart-dialog.component.css']
})

export class EmployeeCartDialogComponent implements OnInit, OnDestroy {
  public projectId!: number;
  public groupId!: number;
  public docList: any[] =[];
  public userId !: number;
  memberList: ProjectMemberModel[] = [];
  projectSelectedMembers: DocumentShareMemberModel[] = [];
  cartDataSource: DocumentShareMemberModel[] = [];
  cartSelectedList: any[] =[];
  cartRequest = {};
  cartSelectedListCopy: any[] =[];
  UnsubscribeArray:Subscription[]=[];

  constructor(
    public dialogRef: MatDialogRef<EmployeeCartDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public projectMemberLinkService: ProjectMemberLinkService,
    private _docService: DocumentService,
    private _notificationService: NotificationService,
  ) { }

  ngOnInit() {
    this.projectId = this.data['projectId'];
    this.groupId = this.data['groupId'];
    this.docList = this.data['docList'];
    this.userId = this.data['userId'];
    this.getMemberList();
    this.getSelectedMemberList();
  }

  async getMemberList() {
    this.memberList = await this.projectMemberLinkService.getSelectedMemberList(this.projectId, this.groupId).toPromise();
    this.setCartValues();
  }

  async getSelectedMemberList() {
    if (this.docList.length == 1) {
      this.projectSelectedMembers = await this._docService.getDocumentShareList(this.docList[0].docId, this.docList[0].revision).toPromise();
    }
    else {
      this.projectSelectedMembers = [];
    }
    if (this.projectSelectedMembers.length > 0) {
      this.memberList = this.changeKeyFormat(this.memberList, this.projectSelectedMembers);
    }
    this.setCartValues();
  }

  changeKeyFormat(inputArr:ProjectMemberModel[] = [], alreadySelectedMembers: DocumentShareMemberModel[]) {
    let grpdSelectedMembers = groupBy(alreadySelectedMembers, 'memberId');
    let outputArr: any[] = [];
    inputArr.forEach(eachObj => {
      let output:any = {};
      output['memberId'] = eachObj['memberId'];
      output['memberName'] = eachObj['memberName'];

      if (!(grpdSelectedMembers && grpdSelectedMembers[output['memberId']] && grpdSelectedMembers[output['memberId']].length)) {
        outputArr.push(output);
      }
    });
    return outputArr;
  }

  closeDialog() {
    this.dialogRef.close();
  }

  setCartValues() {
    this.cartDataSource = this.removeDuplicates(this.memberList, this.projectSelectedMembers, 'memberId');
    this.cartSelectedList = [];
    this.cartSelectedListCopy = [];
    this.projectSelectedMembers.forEach(eachMember => {
      let cartValue = this.getAsCartSelectedValue(eachMember.memberId, eachMember.memberName);
      this.cartSelectedList.push(cartValue);
      this.cartSelectedListCopy.push(cartValue);
    });
    this.setCartParams();
  }

  removeDuplicates(dataSource: any[], selectedArray: any[], key: string) {
    let filteredArray: any[] = [],
      grpdSelecetedArray = groupBy(selectedArray, key);

    dataSource.forEach((eachData: any) => {
      if (!(grpdSelecetedArray[eachData[key]] && grpdSelecetedArray[eachData[key]].length)) {
        filteredArray.push(eachData);
      }
    });
    return filteredArray;
  }

  getAsCartSelectedValue(value: string | number, text: string) {
    value = value.toString().trim();
    text = text.trim();
    let output = {
      value,
      text: value + ' - ' + text
    };
    return output;
  }

  setCartParams() {
    this.cartRequest = {
      'params': {
        'LockingType': 'P',
        'selectedCartItems': this.cartSelectedList,
      },
      'settings': {
        'mode': 'popup',
        'textField': 'memberName',
        'valueField': 'memberId',
        'cartLabel': 'Choose Items',
        'minimumSelectedItemCount': 0
      },
      'dataSource': this.cartDataSource,
    }
  }

  getSelectedCartItems(event: EIPAutoCompleteEventModel<ProjectMemberModel>[]) {
    this.ShareDocuments(event);
  }

  ShareDocuments(event: EIPAutoCompleteEventModel<ProjectMemberModel>[]) {
    let successCode = 200;
    let successMessage = 'Document Shared Successfully';
    this.docList.forEach(element => 
    {
      event.forEach(member => 
      {
        let memberId = +member.value;
        let alreadySelectedMember = this.projectSelectedMembers.findIndex(x => x.memberId == memberId);
        if (alreadySelectedMember == -1) {
          let inputModel: IDocumentShareModel = {
            DocId: element.docId,
            RevisionNo: element.revision,
            MemberId: memberId,
            UserId: this.userId
          };
          let docshare = this._docService.DocumentShare(inputModel).subscribe((res: StandardOutputModel) => {
            if (res.successCode != 200) {
              successCode = res.successCode;
              successMessage = res.successMessage;
            }
          });
          this.UnsubscribeArray.push(docshare);
        }
      });
      this.projectSelectedMembers.forEach(member => 
      {
        let removedMember = event.findIndex(x => +x.value == member.memberId);
        if (removedMember == -1) {
          let inputModel: IDocumentShareModel = {
            DocId: element.docId,
            RevisionNo: element.revision,
            MemberId: member.memberId,
            UserId: this.userId
          };
          let docshareselectedmem = this._docService.DocumentShare(inputModel).subscribe((res: StandardOutputModel) => {
            if (res.successCode != 200) {
              successCode = res.successCode;
              successMessage = res.successMessage;
            }
          });
          this.UnsubscribeArray.push(docshareselectedmem);
        }
      });
      if (successCode == 200) 
      {
        let newMembers = event.filter(x => {
          let memberId = +x.value;
          if (this.projectSelectedMembers.findIndex(y => y.memberId == memberId) == -1)
            return memberId;
        }).map(z => +z.value).toString();
        let inputModel: IDocumentShareMailModel = {
          DocId: element.docId,
          RevisionNo: element.revision,
          MemberIdString: newMembers,
          UserId: this.userId
        };
        let docsharemail = this._docService.DocumentShareMail(inputModel).subscribe((res: StandardOutputModel) => {
          if (res.successCode != 200) {
            successCode = res.successCode;
            successMessage = res.successMessage;
          }
        });
        this.UnsubscribeArray.push(docsharemail);
      }
    });

    if (successCode == 200) {
      this._notificationService.showToast(successMessage, "Success");
    }
    else {
      this._notificationService.showToast(successMessage, "Warning");
    }
    this.dialogRef.close();
  }

  ngOnDestroy():void
  {
    this.UnsubscribeArray.forEach(x=>x.unsubscribe());
  }

}
